import { ZodError, z } from 'zod';

import { emailInvalidMsg, emailRequiredMsg, passwordRequiredMsg } from './constants';
import type { SignInFormValues } from './types';

export const signInFormSchema = z
    .object({
        email: z
            .string()
            .trim()
            .refine(email => email !== '', {
                message: emailRequiredMsg,
            })
            .refine(email => email === '' || z.string().email().safeParse(email).success, {
                message: emailInvalidMsg,
            }),
        password: z.string().trim().min(1, passwordRequiredMsg),
    })
    .strict();

export const signInFormSoftSchema = z
    .object({
        password: z.string().trim().min(1, passwordRequiredMsg),
    })
    .strict();

export function validateSignInForm(
    values: SignInFormValues,
    isSoftAuthenticated?: boolean
): { [key: string]: string[] | undefined } | undefined {
    try {
        isSoftAuthenticated ? signInFormSoftSchema.parse(values) : signInFormSchema.parse(values);
    } catch (error) {
        if (error instanceof ZodError) {
            return z.flattenError(error).fieldErrors;
        }
    }

    return undefined;
}
